import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory, useParams } from 'react-router';
import { setData } from '../../../features/ecBindingSlice';
import Button from '../../shared/Button';
import Header from './Header';
import PageTitle from './PageTitle';
import LogoImage from './LogoImage';
import AccountPlaceHolder from './AccountPlaceHolder';
import BindBtnBackgroundColor from './BindBtnBackgroundColor';
import config from '../../../app/config';
import Preview from '../../shared/BindPage';
import Tip from '../../shared/Tip';
import { color } from '../../../app/theme';

const useStyles = makeStyles(
  {
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
    },
    setting: {},
    preview: {
      width: 360,
      paddingTop: 89,
      height: 729,
      marginLeft: 44,
    },
    sun: {
      marginTop: 24,
      display: 'flex',
      alignItems: 'center',
      fontSize: '13px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      letterSpacing: 'normal',
      color: color.$7,
      background: color.$15,
      width: 80,
      borderRadius: '20px',
      justifyContent: 'center',
      padding: '2px 0',
      marginBottom: 6,
    },
    hint: {
      fontSize: '13px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      color: color.$13,
      marginBottom: 44,
    },
    tip: {
      marginBottom: 44,
    },
  },
  {
    name: 'Step3Container',
  },
);

const Step3Container = ({ provider }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const history = useHistory();
  const { orgId } = useParams();
  const dispatch = useDispatch();
  const { data, isSaved } = useSelector(store => store.ecBinding);
  const { bindPage } = data || {};
  const {
    pageTitle,
    btnBgColor: bindBtnBackgroundColor,
    accountPlaceHolder,
  } = bindPage || {};

  const handlePageTitleChange = value => {
    dispatch(
      setData({
        bindPage: {
          ...bindPage,
          pageTitle: value,
        },
      }),
    );
  };

  const handleLogoImgChange = value => {
    dispatch(
      setData({
        bindPage: {
          ...bindPage,
          logoImageUrl: value,
        },
      }),
    );
  };

  const handleLogoImgReset = () => {
    dispatch(
      setData({
        bindPage: {
          ...bindPage,
          logoImageUrl: config.DEFAULT_LOGO_IMAGE_URL,
        },
      }),
    );
  };

  const handleAccountPlaceHolderChange = value => {
    dispatch(
      setData({
        bindPage: {
          ...bindPage,
          accountPlaceHolder: value,
        },
      }),
    );
  };

  const handleBindBtnBackgroundColorChange = value => {
    dispatch(
      setData({
        bindPage: {
          ...bindPage,
          btnBgColor: value,
        },
      }),
    );
  };

  const handleNext = () => {
    history.push(`/${provider}/${orgId}/step4`);
  };

  return (
    <div className={classes.root}>
      <div className={classes.setting}>
        <Header />
        <PageTitle
          pageTitle={pageTitle}
          onChange={handlePageTitleChange}
          isSaved={isSaved}
        />
        <LogoImage
          onChange={handleLogoImgChange}
          onReset={handleLogoImgReset}
        />
        <AccountPlaceHolder
          accountPlaceHolder={accountPlaceHolder}
          onAccountPlaceHolderChange={handleAccountPlaceHolderChange}
        />
        <BindBtnBackgroundColor
          bindBtnBackgroundColor={bindBtnBackgroundColor}
          onColorChange={handleBindBtnBackgroundColorChange}
        />
        <Tip className={classes.tip} text={t('ecBinding:step3-hint')} />
        <Button topic="primaryGreen" onClick={handleNext}>
          {t('next')}
        </Button>
      </div>
      <div className={classes.preview}>
        <Preview data={data} />
      </div>
    </div>
  );
};

export default Step3Container;
